import BaseResource from './base-resource';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';

export default class GroupResource extends BaseResource {
  name: string;

  constructor(init?: Partial<GroupResource>, type?: string) {
    super(init, type);
  }
}



// WEBPACK FOOTER //
// ./common/models/group-resource.ts